import { render, staticRenderFns } from "./FullReport.vue?vue&type=template&id=21275de6&"
import script from "./FullReport.js?vue&type=script&lang=js&"
export * from "./FullReport.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports